import { useTheme } from "@emotion/react";
import { Container, useMediaQuery } from "@mui/material";
import React from "react";
import Footer from "../Footer/Footer";
import Navigation from "../Navigation/Navigation";
import SideBar from "../SideBar/SideBar";

const Layout = ({ children, darkMode, pyyy = 10, zcoreclub = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <React.Fragment>
      <Container
        sx={
          darkMode
            ? { backgroundColor: "#040404" }
            : { backgroundColor: "#ffffff" }
        }
      >
        <Navigation darkMode={darkMode} />
        <SideBar darkMode={darkMode} />
        {zcoreclub ?
            <Container sx={isMobile ? { py: pyyy, px: 0 } : { mt: -10 }}>
              {children}
            </Container>
          :
            <Container sx={isMobile ? { py: 10 } : { mt: -10 }}>
              {children}
            </Container>
        }
      </Container>
      {!isMobile && <Footer darkMode={darkMode} />}
    </React.Fragment>
  );
};

export default Layout;
